import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=7e5aee16&"
import script from "./CategoriesMenu.js?vue&type=script&lang=js&"
export * from "./CategoriesMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CategoriesMenu.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fheader%2FCategoriesMenu%2FdefaultMenu%2FCategoriesMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports